import { getShareFrom, getOriginFrom } from 'ym-reporter-vue';
import request from '@/utils/request';

export function getProgramDetail(id) {
  return request({
    url: '/AudioProgram/detail',
    params: { id },
  });
}

export function getProgramList(params, silentRequest = false) {
  return request({
    url: '/AudioProgram/explore',
    params,
    silentRequest,
  });
}

export function collectPlayCount(baseUrl, options) {
  const data = Object.assign({
    shareFrom: getShareFrom(),
    originFrom: getOriginFrom(),
  }, options);
  return request({
    baseUrl,
    url: '/',
    method: 'POST',
    data,
    silentRequest: true,
  });
}

export function collectLogData(baseUrl, options) {
  const data = Object.assign({
    shareFrom: getShareFrom(),
    originFrom: getOriginFrom(),
  }, options);
  return request({
    baseUrl,
    url: '/',
    method: 'POST',
    data,
    silentRequest: true,
    json: true,
  });
}
